import { useState } from "react";

const ACCENT = "#4096ff";
const TEXT_PRIMARY = "#1a2332";

export function AdvisorCard({ anggota }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: 160,
        minWidth: 160,
        flexShrink: 0, 
        cursor: "default",
        transition: "transform 0.25s ease",
        transform: hovered ? "translateY(-6px)" : "translateY(0)",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: 180,
          minHeight: 180,
          maxHeight: 180, 
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: hovered
            ? "0 16px 40px rgba(64,150,255,0.18)"
            : "0 4px 16px rgba(0,0,0,0.10)",
          transition: "box-shadow 0.25s ease",
          background: "#e8edf5",
          flexShrink: 0,
        }}
      >
        <img
          src={anggota.image}
          alt={anggota.nama}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center top",
            display: "block",
          }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${ACCENT}, #a78bfa)`,
            opacity: hovered ? 1 : 0,
            transition: "opacity 0.25s ease",
          }}
        />
      </div>

      <div style={{ marginTop: 10, textAlign: "center", padding: "0 4px" }}>
        <span
          style={{
            display: "block",
            fontSize: 13,
            color: TEXT_PRIMARY,
            fontFamily: "'Quicksand', sans-serif",
            lineHeight: 1.4,
            fontWeight: "bold",
          }}
        >
          {anggota.nama}
        </span>
        <span
          style={{
            display: "block",
            fontSize: 11,
            color: ACCENT,
            fontFamily: "'Quicksand', sans-serif",
            marginTop: 3,
            fontWeight: 600,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
          }}
        >
          {anggota.jabatan}
        </span>
      </div>
    </div>
  );
}